// extracted by mini-css-extract-plugin
export default {"title":"style_title__bWdym","sub-title":"style_sub-title__KjN1s"};